<template>
  <div class="presupuesto-interno-comisiones">
    <b-card class="presupuesto-totales">
      <template slot="header">
        Comisiones
        <template v-if="showComisiones">
          <i class="fa fa-plus add-comision"
              @click.prevent="agregarComision">
            <span >Agregar Comisión</span>
          </i>
        </template>
      </template>
  
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showComisiones= !showComisiones">
        <i :class="showComisiones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="totales" class="mt-2" v-model="showComisiones">
        <b-table 
            class="registro"
            responsive="sm" 
            :items="vendedoresComisiones" 
            :fields="fields">
          <template v-slot:cell(vendedor)="data">
            <template v-if="data.item.comisionInterna">
              COMERCIAL
            </template>
            <template v-else>
              {{ data.item.vendedorNombre }}
            </template>
          </template>
          <template v-slot:cell(pjeComision)="data">
            <template v-if="data.item.tipoComision == 1 || data.item.tipoComision == 3">
              {{ data.item.pjeComision | numero(2) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
          <template v-slot:cell(importe)="data">
            <template v-if="data.item.tipoComision == 2 || data.item.tipoComision == 3">
              {{ data.item.importe | moneda(monedaSimbolo) }}
            </template>
            <template v-else>
              --.--
            </template>
          </template>
          <template v-slot:cell(opciones)="data">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item
                  :disabled="data.item.isFacturado" 
                  @click.stop="editarComision(data.item)">
                <i class="fa fa-edit"></i>Editar Comisión</b-dropdown-item>
              <b-dropdown-item
                  :disabled="data.item.isFacturado"  
                  @click.stop="borrarComision(data.item)">
                <i class="fa fa-remove"></i>Borrar Comisión</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
  
        <b-form>
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6">
              <b-form-group
                label="Comisión"
                label-for="totalComisiones"
                :label-cols="2"
                description="Total de comisiones de vendedores"
                horizontal>
                <b-form-input 
                  id="totalComisiones"
                  :value="totalComisiones | moneda(monedaSimbolo)" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'Comisiones',
  props: {
    isAdicional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: [
        {
          key: 'vendedor',
          label: 'Vendedor'
        },
        {
          key: 'pjeComision',
          class: "text-right"
        },
        {
          key: 'importe',
          label: 'Importe Comision',
          class: "text-right"
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      showComisiones: false
    }
  },
  computed: {
    ...mapFields([
      'vendedoresComisiones',
      'montoBaseComision',
      'monedaId',
      'accesoComisiones'
    ]),
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    totalComisiones() {
      let totalComisiones = 0;
      if (Array.isArray(this.vendedoresComisiones) && this.vendedoresComisiones.length > 0) {
        this.vendedoresComisiones.forEach(vendedorComision => {
          switch (vendedorComision.tipoComision) {
            case 1: /* Porcentaje */
              totalComisiones += parseFloat(this.montoBaseComision) * parseFloat(vendedorComision.pjeComision) / 100;
              break;
    
            case 2: /* Importe */
              totalComisiones += parseFloat(vendedorComision.importe);
              break;
    
            case 3: /* Porcentaje + Importe */
              totalComisiones += parseFloat(this.montoBaseComision) * parseFloat(vendedorComision.pjeComision) / 100 
                + parseFloat(vendedorComision.importe);
              break;
          }
        });
      }

      return totalComisiones;
    }
  },  
  created() {
  },
  methods: {
    // setVendedorComision() {
    //   this.$emit('setVendedorComision');
    // },
    agregarComision() {
      this.$emit('agregarComision');
    },
    editarComision(item) {
      this.$emit('editarComision', item);
    },
    borrarComision(item) {
      this.$emit('borrarComision', item);
    }
    // calcularComisiones() {
    //   if (Array.isArray(this.vendedoresComisiones) && this.vendedoresComisiones.length > 0) {
    //     this.vendedoresComisiones.forEach(vendedorComision => {
    //       switch (vendedorComision.tipoComision) {
    //         case 1: /* Porcentaje */
    //           return parseFloat(this.montoBaseComision) * parseFloat(vendedorComision.pjeComision) / 100;

    //         case 2: /* Importe */
    //           return parseFloat(vendedorComision.importe);

    //         case 3: /* Porcentaje + Importe */
    //           return parseFloat(this.montoBaseComision) * parseFloat(vendedorComision.pjeComision) / 100 
    //             + parseFloat(vendedorComision.importe);
    //       }
          
    //     });
    //   }
    // },
  },
}
</script>

<style>
  .presupuesto-interno-comisiones .card-header i.add-comision {
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    cursor: pointer;
    margin-left: 12px;
    top: 2px; 
  }
  .presupuesto-interno-comisiones .card-header i.add-comision:hover {
    color: #20a8d8;
  }
  .presupuesto-interno-comisiones .card-header span {
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    top: -2px;
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    margin-left: 5px;
  }
  .presupuesto-interno-comisiones .card-header i.add-comision:hover span{
    color: #20a8d8;
  }

  .presupuesto-interno-comisiones table thead th {
    border-top: none;
  }
  .presupuesto-interno-comisiones .registro table td[aria-colindex="1"] {
    width: calc(60% - 45px);
  }
  .presupuesto-interno-comisiones .registro table td[aria-colindex="2"] {
    width: 20%;
  }
  .presupuesto-interno-comisiones .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .presupuesto-interno-comisiones .registro table td[aria-colindex="4"] {
    width: 45px;
  }

</style>
